goog.provide('el8.uiwidget.DrawerDialog');

goog.require('el8.uiwidget.NewDialog');
goog.require('el8.uiwidget.Drawer');
goog.require('el8.model.base');


/**
 * A DrawerDialog contains a "Drawer" that can be pulled out
 * to display some additional detail. See Drawer.js
 *
 * We use it for med history (the drawer contains details on a single med,
 * while the main dialog contains details on the thread, e.g.).
 */
el8.uiwidget.DrawerDialog = function(spec) {

    spec = spec || {};

    el8.uiwidget.NewDialog.apply(this, arguments);

    this._drawerConstructor = spec.drawerConstructor || el8.uiwidget.Drawer;
    this._drawerOpts = spec.drawerOpts || {};
    this._drawerWidth = this._drawerOpts.width || 100;
    this._drawerHeight = this._drawerOpts.height || 300;
    this._drawerOpts['leftOffsets'] = {
        start: (this._width - this._drawerWidth),
        end: this._width
    };
};
el8.uiwidget.DrawerDialog.inheritsFrom(el8.uiwidget.NewDialog);

el8.uiwidget.DrawerDialog.prototype._init = function() {

    el8.uiwidget.NewDialog.prototype._init.apply(this, arguments);

    /**
     * Do surgical fixes to enable drawer behavior
     */
    var dialogContainer = this.getDialogContainer();
    dialogContainer.removeClass('el8Dialog').addClass('el8DrawerDialog');
    $('.ui-dialog-titlebar', dialogContainer).addClass('el8DrawerDialogTitle');
    $('.ui-dialog-content', dialogContainer).addClass('el8DrawerDialogBody');
    this._adjustSize();

    this._drawer = new this._drawerConstructor(this._drawerOpts);
    this._drawer.attachTo(dialogContainer);

    var that = this;

    this._drawer.getContainer().on('click', '.drawer-close-trigger',  function(e) {
        that.closeDrawer();
    });

    var super_drawerHide = this._drawer.hide;
    this._drawer.hide = function(var_args) {
        that.getDialogContainer().outerWidth(that._width);
        super_drawerHide.apply(that._drawer, arguments);
    };

    var super_drawerShow = this._drawer.show;
    this._drawer.show = function(var_args) {
        that.getDialogContainer().outerWidth(that._width + that._drawerWidth);
        that._adjustSize();
        super_drawerShow.apply(that._drawer, arguments);
    };

};

el8.uiwidget.DrawerDialog.prototype._adjustSize = function() {
    var titleElt = this.getTitleElt();
    var titleMargin = titleElt.outerWidth(true) - titleElt.width();
    titleElt.width(this._width - titleMargin);

    var dialogContentElt = this.getDialogContentElt();
    var dialogContentMargin = dialogContentElt.outerWidth(true) - dialogContentElt.width();
    dialogContentElt.width(this._width - dialogContentMargin);
};

el8.uiwidget.DrawerDialog.prototype._computeSpaceToRight = function() {
    var dialogOffsetLeft = this.getDialogContainer().offset().left +
        this.getDialogContainer().outerWidth(true);
    var windowWidth = $(window).width();
    return windowWidth - dialogOffsetLeft;
};

el8.uiwidget.DrawerDialog.prototype.openDrawer = function(var_args) {
    if (this._drawer) {
        if (!this._drawer.isShowing()) {
            // Move dialog over if drawer will be covered
            if (this._drawerWidth > this._computeSpaceToRight()) {
                var moveOver = this._drawerWidth - this._computeSpaceToRight();
                var currOffsets = this._container.dialog('option', 'position');
                if (currOffsets && (currOffsets.length > 1)) {
                    var newLeftOffset = currOffsets[0] - moveOver - 10; // buffer
                    this._container.dialog('option', 'position', $.ui.dialog.getPositionObject([newLeftOffset, currOffsets[1]]));
                }
            }
        }
        this._drawer.show.apply(this._drawer, arguments);
    }
};

el8.uiwidget.DrawerDialog.prototype.closeDrawer = function() {
    if (this._drawer) {
        this._drawer.hide();
    }
};

el8.uiwidget.DrawerDialog.prototype.getDrawerContainer = function() {
    if (this._drawer) { return this._drawer.getContainer(); }
};

el8.uiwidget.DrawerDialog.prototype.getDrawer = function() {
    if (this._drawer) { return this._drawer; }
};
